import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

async function getBartrackLines(orgId) {
  try {
    const q = query(collection(db, "Bartracks"), where("orgId", "==", orgId));
    const snapshot = await getDocs(q);

    const totalLines = await Promise.all(
      snapshot.docs.map(async (doc) => {
        const linesSnapshot = await getDocs(collection(db, "Bartracks", doc.id, "Lines"));
        const lines = linesSnapshot.docs.map((lineDoc) => ({
          id: lineDoc.id,
          ...lineDoc.data(),
        }));

        return lines;
      }),
    );

    return totalLines.flat();
  } catch (error) {
    console.error("Erreur lors de la récupération des bartracks :", error);
    return [];
  }
}

export default getBartrackLines;
